import React from 'react';
import { Button } from 'react-bootstrap';
import { FaEye, FaVideo, FaHashtag, FaFilm, FaCalendarAlt, FaClock } from 'react-icons/fa';

const MeetingMobileCard = ({ meeting, handleView, handleJoin }) => {
  const isExpired = meeting.statusVal === 'EXPIRED';

  return (
    <div className="project-mobile-card mb-3">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div>
          <h6 className="project-card-title m-0 text-white fw-bold">{meeting.roleName || 'Audition Meeting'}</h6>
          <small className="text-warning fw-bold">{meeting.projectName || 'Project'}</small>
        </div>
        <span className={`pmp-status-tag ${isExpired ? 'pmp-status-expired' : 'pmp-status-active'}`}>
          {meeting.statusVal || 'BOOKED'}
        </span>
      </div>

      <div className="card-data-grid mt-2 mb-2">
        <div className="data-item">
          <FaHashtag className="text-info" />
          <span className="lbl">App ID:</span>
          <span className="val text-truncate font-monospace">#{meeting.applicationId}</span>
        </div>
        <div className="data-item">
          <FaFilm className="text-warning" />
          <span className="lbl">Type:</span>
          <span className="val text-truncate">{(meeting.bookingType || 'Audition').replaceAll('_', ' ')}</span>
        </div>
        <div className="data-item">
          <FaCalendarAlt className="text-success" />
          <span className="lbl">Date:</span>
          <span className="val text-truncate">{meeting.formattedDate}</span>
        </div>
        <div className="data-item">
          <FaClock className="text-danger" />
          <span className="lbl">Time:</span>
          <span className="val text-truncate fw-bold text-info">{meeting.formattedTime}</span>
        </div>
      </div>

      <hr className="compact-hr my-2" />

      <div className="d-flex justify-content-between align-items-center">
        <Button
          variant="outline-info"
          size="sm"
          className="d-flex align-items-center gap-1 py-1 px-3"
          onClick={() => handleView(meeting)}
          style={{ fontSize: '12px' }}
        >
          <FaEye /> View Details
        </Button>

        <Button
          variant={isExpired ? "secondary" : "success"}
          size="sm"
          className="d-flex align-items-center gap-1 py-1 px-3 fw-bold shadow-sm"
          disabled={isExpired}
          onClick={() => handleJoin(meeting)}
          style={{ fontSize: '12px' }}
        >
          <FaVideo /> {isExpired ? "Expired" : "Join Meeting"}
        </Button>
      </div>
    </div>
  );
};

export default MeetingMobileCard;
